
import React from "react";
import { ArrowLeft, UserPlus } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import PartnerForm from "@/components/forms/PartnerForm";
import { useToast } from "@/components/ui/use-toast";
import { useNavigate } from "react-router-dom";

const NewPartner: React.FC = () => {
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleSuccess = () => {
    toast({
      title: "Επιτυχής προσθήκη!",
      description: "Ο συνεργάτης προστέθηκε επιτυχώς.",
    });
    navigate("/admin/partners");
  };

  return (
    <div className="space-y-8 animate-fade-in">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex items-center gap-3">
          <Button variant="outline" size="icon" asChild className="rounded-full h-10 w-10 border-slate-200">
            <Link to="/admin/partners">
              <ArrowLeft className="h-5 w-5 text-slate-600" />
            </Link>
          </Button>
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-br from-emerald-500 to-green-600 shadow-md">
              <UserPlus className="h-5 w-5 text-white" />
            </div>
            <div>
              <h1 className="text-xl md:text-2xl font-bold text-slate-900">Νέος Συνεργάτης</h1>
              <p className="text-sm text-slate-500">
                Προσθήκη νέου συνεργάτη στο δίκτυο
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-6">
        <PartnerForm onSuccess={handleSuccess} isAdminView={true} />
      </div>
    </div>
  );
};

export default NewPartner;
